import { render } from "./AuthentView.vue?vue&type=template&id=35db2306"
import script from "./AuthentView.vue?vue&type=script&lang=js"
export * from "./AuthentView.vue?vue&type=script&lang=js"

import exportComponent from "/home/ramo/backend/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__